/**
 * weekly-top-10
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import renderWeeklyReport from "./render-weekly-report";
import removeInitialViewClass from "../common/remove-initial-view-class";

export default numberOfProgrammes => sb => {
    let form;

    let stations = [];
    let selectedStations = [];
    let selectedPeriods = [];

    let errorMsg;
    let submit;

    const maybeShowError = () => {
        const tooMany = selectedStations.length > 1 && selectedPeriods.length > 1;
        const noStations = stations.length > 0 && selectedStations.length < 1;
        const noWeeks = sb.find('#period_week > option').length > 0 && selectedPeriods.length < 1;

        if (tooMany || noStations || noWeeks) {
            errorMsg.css("display", "block");
            submit[0].disabled = "disabled";
        } else {
            errorMsg.css("display", "none");
            submit[0].disabled = null;
        }
    };

    const renderReport = data => {
        let html = renderWeeklyReport(numberOfProgrammes === 10 ? "000s" : "Millions")(
            data,
            id => stations.find(
                station => parseInt(station.id, 10) === parseInt(id, 10)
            )
        );

        let report = sb.find("div.scroll_datagrid");
        sb.empty(report).append(report, html);

        removeInitialViewClass(sb);
    };

    const showPleaseWait = () => {
        let report = sb.find("div.scroll_datagrid");
        sb.empty(report).append(report, "Please wait...");
    };

    const formSubmit = (e, callback) => {
        e.preventDefault();
        const data = {
            method: "POST",
            station: selectedStations,
            period: selectedPeriods
        };

        sb.postApi("/whats-new/weekly-top-" + numberOfProgrammes, data).then(callback);

    };

    const onFormSubmit = e => {
        showPleaseWait();
        formSubmit(e, renderReport);
    };

    return {
        init() {
            form = sb.find("form");
            errorMsg = form.query("div.invalid_input_message");
            submit = form.query("#button_submit");

            errorMsg.css("display", "none");

            sb.addEvent(form, "submit", onFormSubmit);

            sb.listen({
                stationsLoaded: loadedStations => stations = loadedStations,
                stationsSelectionChanged: stns => {
                    selectedStations = stns;
                    maybeShowError();
                },
                periodsSelectionChanged: periods => {
                    selectedPeriods = periods;
                    maybeShowError();
                }
            });
        },
        destroy() {
            sb.ignore([
                "stationsLoaded",
                "stationsSelectionChanged",
                "periodsSelectionChanged"
            ]);

            sb.removeEvent(form, "submit", onFormSubmit);

            form = null;
            errorMsg = null;
            submit = null;
        }
    }
};

